<template>
  <button @click="handleClickSettings">
    <span class="icon-container">
      <icon class="icon" name="nomad:pen" size="1.5rem" />
    </span>

    <span>Éditer</span>
  </button>
</template>
<script setup lang="ts">
import DialogLibrarySettings from '~/components/dialog/library/settings/DialogLibrarySettings.vue';

const dialog = useDialogStore();

const handleClickSettings = () => {
  dialog.open(DialogLibrarySettings, {
    level: DialogLevel.Settings,
  });
};
</script>
<style lang="scss" scoped>
// TODO Fix theme
button {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  width: 100%;
  padding: var(--gap_s);
  border-radius: 2rem;
  background-color: var(--color_neutral_25);
  color: var(--color_secondary_darker);
  text-align: left;
  gap: var(--gap_s);
  @include font('s', 500, 'secondary');

  &.main {
    color: var(--color_secondary);
  }
  .icon-container {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      transform-origin: 5% 90%;
      border-radius: 50%;
      background-color: var(--color_secondary_lighter);
    }
  }
  .icon {
    position: relative;
    z-index: 1;
    transform-origin: 0 100%;
    transition: transform 200ms $ease-in-quad;
    color: var(--color_secondary_darker);
  }

  &:hover,
  &:focus,
  &.active,
  &.router-link-active,
  &.router-link-exact-active-with-hash {
    @include pointer-desktop {
      .icon-container {
        color: var(--color_secondary);
      }
      .icon {
        transform: scale(1.4);
        transition: transform 300ms $ease-out-quad;
      }

      color: var(--color_secondary);
    }
  }
}
</style>
